const RefreshBtn = (props: any) => {
  return (
    <button className="click-btn" onClick={() => window.location.reload()}>
      {props.text}
    </button>
  );
};

export default RefreshBtn;
